export { FeaturedIcons } from './FeaturedIcons';
